'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Admonition } from './admonition';

export const Warning = (props: React.PropsWithChildren) => {
  const t = useTranslations();
  const { children } = props;

  return (
    <Admonition severity="error" title={t('mdx:alert:warning')}>
      {children}
    </Admonition>
  );
};
